import { Injectable } from '@angular/core';

import { IEventConfig } from '../models/analytics.config.interface';
import { TealiumAnalyticsEvent } from '../models/tealium-analytics-event';
import { TealiumAnalyticsService } from '../services/tealium-analytics.service';
import { AnalyticsAdapterInterface } from './analytics-adapter.interface';

@Injectable()
export class TealiumAnalyticsAdapter implements AnalyticsAdapterInterface {
	constructor(private tealiumAnalyticsService: TealiumAnalyticsService) { }

	public buildAnalyticsEvent(eventConfig: IEventConfig, isNewAnalysis?: boolean): TealiumAnalyticsEvent {
		const mode = window['globalAnalyticsParams'] && window['globalAnalyticsParams']['mode'] ? window['globalAnalyticsParams']['mode'] + ' : ' : '';
		const toolFlow = eventConfig.toolFlow ? eventConfig.toolFlow : '';
		let legacyLink = `${mode}${eventConfig.linkName}`;
		if (eventConfig.legacyFlow) {
			legacyLink += eventConfig.legacyFlow;
			if (!isNewAnalysis) {
				legacyLink += ' pop-up';
			}
		} else {
			legacyLink += toolFlow;
		}

		const event = new TealiumAnalyticsEvent(eventConfig.eventName, {
			eventNumber: eventConfig.eventNumber,
			toolFlow: eventConfig.toolFlow,
			toolName: legacyLink
		});

		return event;
	}
	public sendAnalyticsEvent(event: TealiumAnalyticsEvent): void {
		this.tealiumAnalyticsService.trackEventTealium(event);
	}
	public trackPageChangeEvent(pageName: string, pageUrl: string): void {
		this.tealiumAnalyticsService.trackPageChangeEvent(pageName, pageUrl);
	}
}
